import { types } from "./contasreceberrelatorio.actions";
import { Reducer } from "../../services/reducer.factory";
import storage from "../../services/stoage.service";
import moment from "moment";

const initialState = {
  id: "contasreceberrelatorio",
  columns: [],
  currentRecord: {
    oid: "",
    dataInicial: new Date(),
    dataFinal: new Date(),
    dataVencimentoInicial: new Date(),
    dataVencimentoFinal: moment().endOf("month").startOf("day").toDate(),
    tiposSepulturas: [],
    tipoRelatorio: 1
  },
  messages: null,
  selectedFilters: [],
  usaListDto: false
};

const reducer = new Reducer(initialState, types);

export function CRUDContasReceberRelatorioReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels("contasreceberrelatorio");
  }
  state = reducer.execute(state, action);
  return execute(state, action);
}

function execute(state, action) {
  let result = state;
  switch (action.type) {
    case types.SET_BOOLEAN_FILTER:
      return setBooleanFilter(state, action);
    default:
      return result;
  }
}

function setBooleanFilter(state, action) {
  let booleanFilter = Object.assign({}, state.booleanFilter);
  booleanFilter[action.field] = action.value;
  return Object.assign({}, state, { booleanFilter });
}
